import React from 'react';
import pomegranates_image from "../images/pomegranates_image.png";
import {Link} from "react-router-dom";
import {motion} from "framer-motion";
import { LuSoup } from "react-icons/lu";
import { FaPizzaSlice } from "react-icons/fa";
import { GiWineBottle } from "react-icons/gi";
import { CiCoffeeCup } from "react-icons/ci";

const NavigationPage = () => {
    return (
        <motion.div
            exit={{
                opacity: 0,
                transition: {
                    delay: 0.25
                }
            }} className="h-screen w-full bg-[#D9D9D9]">
            <div className="flex flex-col mx-auto h-full relative">
                <img src={pomegranates_image} className="w-full" alt="Separator image"/>
                <div className={'flex flex-col w-11/12 mx-auto grow my-5 place-items-center gap-10 lg:gap-5'}>
                    <motion.button
                        className={' group active:bg-[#de0034] ease-in-out active:text-white transition duration-250 shadow shadow-lg shadow-red-300 w-full h-full bg-white flex items-center justify-center px-10 py-5 text-center rounded-t-2xl'}
                        initial={{
                            opacity: 0,
                        }}
                        animate={{
                            opacity: 1,
                            transition: {
                                duration: 0.2,
                                delay: 0.05,
                            }
                        }}
                    >
                        <Link className={`group-active:text-white flex flex-col items-center justify-between w-full font-bold h-full sm:text-5xl  text-3xl`} to={'/main-menu'}>ОСНОВНЕ МЕНЮ <LuSoup className={'group-active:text-white text-[#de0034] text-5xl'}/></Link>
                    </motion.button>

                    <motion.button
                        className={' group active:bg-[#de0034] ease-in-out active:text-white transition duration-250 shadow shadow-lg shadow-red-300 w-full h-full bg-white flex items-center justify-center px-10 py-5 text-center'}
                        initial={{
                            opacity: 0,
                        }}
                        animate={{
                            opacity: 1,
                            transition: {
                                duration: 0.2,
                                delay: 0.1,
                            }
                        }}
                    >
                        <Link className={'group-active:text-white flex flex-col items-center justify-between w-full font-bold h-full sm:text-5xl  text-3xl'} to={'/fastfood'}>ФАСТ-ФУД <FaPizzaSlice className={'group-active:text-white text-[#de0034] text-5xl'}/></Link>
                    </motion.button>

                    <motion.button
                        className={'active:bg-[#de0034] group  ease-in-out active:text-white transition duration-250 shadow shadow-lg shadow-red-300 w-full h-full bg-white flex items-center justify-center px-10 py-5 text-center'}
                        initial={{
                            opacity: 0,
                        }}
                        animate={{
                            opacity: 1,
                            transition: {
                                duration: 0.2,
                                delay: 0.15,
                            }
                        }}
                    >
                        <Link className={'group-active:text-white flex flex-col items-center justify-between w-full font-bold h-full sm:text-5xl  text-3xl'} to={'/alcohol'}>АЛКОГОЛЬ <GiWineBottle className={'group-active:text-white text-[#de0034] text-6xl'}/></Link>
                    </motion.button>

                    <motion.button
                        className={'active:bg-[#de0034] group  ease-in-out active:text-white transition duration-250 shadow shadow-lg shadow-red-300 w-full h-full bg-white flex items-center justify-center px-10 py-5 text-center rounded-b-2xl'}
                        initial={{
                            opacity: 0,
                        }}
                        animate={{
                            opacity: 1,
                            transition: {
                                duration: 0.2,
                                delay: 0.2,
                            }
                        }}
                    >
                        <Link className={'group-active:text-white flex flex-col items-center justify-between w-full font-bold h-full sm:text-5xl  text-3xl'} to={'/drinks'}>НАПОЇ <CiCoffeeCup className={'group-active:text-white text-[#de0034] text-6xl'}/></Link>
                    </motion.button>

                </div>
            </div>
        </motion.div>
    );
};

export default NavigationPage;